// import { ButtonLight } from 'components/Button'
import Loader from 'components/Loader'
import { useTotalFarmTvl } from 'hooks/useKodiakFarm'
import { useContext } from 'react'
// import { useNavigate } from 'react-router-dom'
import styled, { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'
import { formatDollarAmount } from 'utils/formatDollarAmt'

import * as S from '../Liquidity.styles'

// Create Farm button temporarily disabled
// const ButtonContainer = styled.div`
//   max-width: 128px;
// `

const DescriptionText = styled(ThemedText.DeprecatedBody)`
  @media (max-width: 375px) {
    font-size: 13px !important;
  }
`

export default function FarmHeader() {
  // const navigate = useNavigate()
  const theme = useContext(ThemeContext)

  const { isLoading, totalFarmTvl } = useTotalFarmTvl()

  return (
    <S.Header>
      <S.HeaderTitleFlex>
        <ThemedText.DeprecatedBody fontSize="18px" fontWeight="700">
          Farms
        </ThemedText.DeprecatedBody>

        <DescriptionText fontSize="14px" fontWeight="400" color={theme.textSecondary}>
          Deposit into Kodiak&apos;s farms.
        </DescriptionText>
        {/* Create Farm button temporarily disabled
        <ButtonContainer>
          <ButtonLight padding="4px" style={{ fontSize: '14px' }} onClick={() => navigate(`/liquidity/farms/deploy`)}>
            Create Farm
          </ButtonLight>
        </ButtonContainer> */}
      </S.HeaderTitleFlex>
      <S.HeaderBoxFlex>
        <S.HeaderBox>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" color={theme.textSecondary} lineHeight="14px">
            Farm TVL
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            {isLoading ? <Loader /> : formatDollarAmount(totalFarmTvl) || '$0.00'}
          </ThemedText.DeprecatedBody>
        </S.HeaderBox>

        <S.HeaderBoxDesktop>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" color={theme.textSecondary} lineHeight="14px">
            My Deposits
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            $0.00
          </ThemedText.DeprecatedBody>
        </S.HeaderBoxDesktop>
      </S.HeaderBoxFlex>
    </S.Header>
  )
}
